import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { appSettings } from '../../../settings';
@Component({
  selector: 'app-widget-info',
  templateUrl: './widget-info.component.html',
  styleUrls: ['./widget-info.component.scss'],
  outputs: ['onOrderDetailEvent']
})
export class WidgetInfoComponent implements OnInit {
  @Input() widget: any;
  widgetTable:any[] = [];
  selectedRow = [];
  public onOrderDetailEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {
    if (this.widget && this.widget.DataTable != null && this.widget.DataTable.length > 0) {  
      this.widgetTable = this.widget.DataTable;
    }
  }

  onSelect(event) {
    const detail = [];
    switch(this.widget.type){
      case appSettings.CancelOrders:
        if (this.widgetTable && this.widgetTable.length > 0 
            && this.widgetTable[0].rowsMatrix && this.widgetTable[0].rowsMatrix.length > 0) {     
          for (const item of this.widgetTable[0].rowsMatrix) {
            if(item.OrderId == this.selectedRow[0].OrderId){
              detail.push({
                OrderId: item.OrderId,
                Facility: item.Facility,
                Item: item.Item,
                LPId: item.LPId,
                UOM: item.UOM,
                Quantity: item.Quantity,
                PickFromLocation: item.PickFromLocation,
                CancelType: item.CancelType,
                ShippingPlateType: item.ShippingPlateType
              });
            }
          }
           this.onOrderDetailEvent.emit(detail);
        }
      break;
    }    
  }

  customClasses = {
    sortAscending: 'fa fa-sort-asc',
    sortDescending: "fa fa-sort-desc",
    pagerLeftArrow: "fa fa-chevron-left",
    pagerRightArrow: "fa fa-chevron-right",
    pagerPrevious: "fa fa-step-backward",
    pagerNext: "fa fa-step-forward"
  };
}



// WEBPACK FOOTER //
// ./src/app/components/shared/widget-info/widget-info.component.ts